import React from 'react';
import ApexCharts from 'react-apexcharts'; // Import the ApexCharts component
import { ApexOptions } from 'apexcharts';

function StatisticsWigetPerformanceView({statisticsData}:{statisticsData:any}) {

    function formatMinutes(value:any) {
        const visits=value
        return `${visits}`;
    }


    function formatMonthDay(dateString: any) {
        const date = new Date(dateString);
        const day = date.getDate();
        const month = date.toLocaleString('default', { month: 'short' });
        return `${day}${month.toLowerCase()}`;
    }

    const dates = statisticsData.map((data:any) => formatMonthDay(data.date)).reverse()
    const visitCounts = statisticsData.map((data:any) => data.visitCount).reverse()

    const options: ApexOptions = {
        chart: {
            type: 'area',
            height: 350,
        },
        xaxis: {
            categories: dates,
        },
        yaxis: {
            labels: {
                formatter: formatMinutes, // Format y-axis labels using the formatMinutes function
            },
        },
        dataLabels: {
            enabled: false,
        },
        series: [{
            name: 'Visit Count',
            data: visitCounts,
        }],
    };

    return (
        <div>
            <ApexCharts options={options} series={options.series} type="area" height={350} />
        </div>
    );
}


export default StatisticsWigetPerformanceView;
